import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import "./viewProjects.css";
import SearchBar from "../Main/searchBar";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import "./viewProperties.css";
import AmenitiesList from "./amenitiesList";
import { viewProperty } from "../../Redux/Actions/propertyActions";
import RewardPointsPopup from "./rewardPopup";
import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";

const ViewProperties = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { id } = useParams();
  const popupRef = useRef(null);

  const [amenityPopup, setAmenityPopup] = useState(false);
  const [rewardPopup, setRewardPopup] = useState(false);
  const [visibleImages, setVisibleImages] = useState(6);
  const [previewImage, setPreviewImage] = useState(null);
  const [currentStatus, setCurrentStatus] = useState("");
  const [zoom, setZoom] = useState(1);
  const [activeTab, setActiveTab] = useState("overview");

  const closePreview = () => {
    setPreviewImage(null);
    setZoom(1);
  };

  const { enumsData } = useSelector((state) => state.enumsData);
  const { properties, property } = useSelector((state) => state.properties);
  const currency = property?.data?.currency || "";

  const dispatch = useDispatch();

  const handleTabChange = useCallback((tab) => {
    setActiveTab(tab);
  }, []);


  const changeStatusHandler = async (event) => {
    try {
      const selectedOption = event.target.value;
      if (!selectedOption) return;

      await axios
        .post(
          `${BASE_URL}/property/change-status`,
          { property_id: id, status: selectedOption },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(async () => {
          toast.success(`Property Published Successfully!`);
          setCurrentStatus(selectedOption);
          dispatch(viewProperty(id));
        });
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.error("Error at changing status", error.response);
    }
  };

  const togglePopup = useCallback(() => {
    setAmenityPopup(prev => !prev);
  }, []);

  const toggleRewardPopup = useCallback(() => {
    if (rewardPopup) {
      dispatch(viewProperty(id));
    }
    setRewardPopup(prev => !prev);
  }, [rewardPopup, dispatch, id]);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setAmenityPopup(false);
      }
    };

    if (amenityPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [amenityPopup]);

  useEffect(() => {
    console.log("Property data updated:", property);
  }, [property]);

  console.log("DAAT", id)
  useEffect(() => {
    dispatch(viewProperty(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (property?.data?.status) {
      setCurrentStatus(property.data.status);
    }
  }, [property?.data?.status]);

  const foundProperty = useMemo(() => {
    return properties?.data?.find(p => p._id === id);
  }, [properties, id]);


  const totalPrice = useMemo(() => {
    const prices = [
      property?.data?.furnished_price,
      property?.data?.semi_furnished_price,
      property?.data?.unfurnished_price
    ].find(price => price > 0);

    return prices
      ? prices.toLocaleString("en-IN")
      : "N/A";
  }, [property?.data?.furnished_price, property?.data?.semi_furnished_price, property?.data?.unfurnished_price]);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
        gridAutoRows: "minmax(60px, auto)",
        background: "#F5F7FA"
      }}
      className="padding-20 gap-10 grid-container"
    >
      <div style={{ gridColumn: "4/8" }}>
        <SearchBar style={{ width: "max-content" }}></SearchBar>
      </div>

      <div
        className="back-icon margin-0 gap-10 align-center flex-container"
        style={{
          gridColumn: "span 7",
        }}
      >
        <Link to="/manage_properties">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div>
          <h3>
            {property?.data?.project?.project_name}
          </h3>
          <h4
            style={{
              position: "relative",
              top: "-10px",
            }}
          >
            Property/ List/ View
          </h4>
        </div>
      </div>

      {/* Modern Professional UI Container */}
      <div className="modern-property-view">
        {/* Hero Banner */}
        <div className="hero-banner">
          <div className="hero-image-container">
            <img
              src={property?.data?.cover_photos?.[0]?.url}
              alt="Property"
              loading="eager"
              decoding="async"
              className="hero-main-image"
            />
            <div className="hero-overlay">
              <div className="hero-badges">
                <span className="status-pill construction">
                  {property?.data?.construction_status || "N/A"}
                </span>
                <span className="status-pill featured">Featured</span>
              </div>
            </div>
          </div>

          <div className="hero-content-card">
            <div className="project-header">
              <div>
                <h1 className="project-name">
                  {property?.data?.project?.project_name || "N/A"}
                </h1>
                <p className="project-meta">
                  <span>📍</span> {property?.data?.project?.brand_name || "N/A"} • ID: {property?.data?.project?.project_id || "N/A"}
                </p>
              </div>
              <div>
                <span className="price-label">Total Price</span>
                <div className="price-tag-large">
                  <span className="price-value">
                    {currency} {totalPrice}
                  </span>
                </div>
              </div>
            </div>

            <div className="quick-stats">
              <div className="quick-stat-item">
                <span className="stat-icon">🏠</span>
                <div>
                  <span className="stat-number">{property?.data?.no_of_bedroom || "0"}</span>
                  <span className="stat-label">Bedrooms</span>
                </div>
              </div>
              <div className="quick-stat-item">
                <span className="stat-icon">📐</span>
                <div>
                  <span className="stat-number">{property?.data?.unit_area || "N/A"}</span>
                  <span className="stat-label">Sq.ft</span>
                </div>
              </div>
              <div className="quick-stat-item">
                <span className="stat-icon">💰</span>
                <div>
                  {/* <span className="stat-number">₹{property?.data?.price_per_sq_ft?.toLocaleString() || "N/A"}</span> */}
                  <span className="stat-number">
                    {currency} {Number(property?.data?.price_per_sq_ft)?.toLocaleString() || "N/A"}
                  </span>
                </div>
              </div>
              <div className="quick-stat-item">
                <span className="stat-icon">📅</span>
                <div>
                  <span className="stat-number">{property?.data?.project?.launch_date?.slice(0, 7) || "N/A"}</span>
                  <span className="stat-label">Launch Date</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs Navigation */}
        <div className="tabs-navigation">
          <button
            className={`tab-btn ${activeTab === 'overview' ? 'active' : ''}`}
            onClick={() => handleTabChange("overview")}
          >
            Overview
          </button>
          <button
            className={`tab-btn ${activeTab === 'details' ? 'active' : ''}`}
            onClick={() => setActiveTab('details')}
          >
            Specifications
          </button>
          <button
            className={`tab-btn ${activeTab === 'gallery' ? 'active' : ''}`}
            onClick={() => setActiveTab('gallery')}
          >
            Gallery
          </button>
        </div>

        {/* Tab Content - Overview */}
        {activeTab === 'overview' && (
          <div className="tab-content">
            {/* Main Info Grid */}
            <div className="info-grid-modern">
              <div className="info-section-card">
                <h3 className="section-title">Property Information</h3>
                <div className="info-rows">
                  <div className="info-row">
                    <span className="info-key">Type</span>
                    <span className="info-value" style={{ background: "transparent" }}>{property?.data?.unit?.name || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Category</span>
                    <span className="info-value" style={{ background: "transparent" }}>{property?.data?.project_type?.name || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">RERA ID</span>
                    <span className="info-value" style={{ background: "transparent" }}>{property?.data?.project?.rera_id || "N/A"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Tower Name</span>
                    <span className="info-value" style={{ background: "transparent" }}>{property?.data?.tower_name || "No Tower"}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Status</span>
                    <span className="status-badge active">
                      {ToFirstCapital(property?.data?.status) || "N/A"}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-key">Upload Date</span>
                    <span className="info-value" style={{ background: "transparent" }}>{DateToLocale(property?.data?.created_at)}</span>
                  </div>
                </div>
              </div>

              <div className="info-section-card">
                <h3 className="section-title">Configuration</h3>
                <div className="room-grid">
                  <div className="room-item">
                    <span className="room-emoji">🛏️</span>
                    <span className="room-count">{property?.data?.no_of_bedroom || "0"}</span>
                    <span className="room-type">Bedrooms</span>
                  </div>
                  <div className="room-item">
                    <span className="room-emoji">🚿</span>
                    <span className="room-count">{property?.data?.no_of_bathroom || "0"}</span>
                    <span className="room-type">Bathrooms</span>
                  </div>
                  <div className="room-item">
                    <span className="room-emoji">🍳</span>
                    <span className="room-count">{property?.data?.no_of_kitchen || "0"}</span>
                    <span className="room-type">Kitchen</span>
                  </div>
                  <div className="room-item">
                    <span className="room-emoji">🌅</span>
                    <span className="room-count">{property?.data?.no_of_balcony || "0"}</span>
                    <span className="room-type">Balcony</span>
                  </div>
                  <div className="room-item">
                    <span className="room-emoji">☕</span>
                    <span className="room-count">{property?.data?.no_of_pantry || "0"}</span>
                    <span className="room-type">Pantry</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Features Section */}
            <div className="features-section">
              <div className="feature-card accent-blue">
                <h4 className="feature-title">Property Facing</h4>
                <div className="feature-tags">
                  {Array.isArray(property?.data?.property_facing) && property.data.property_facing.length > 0 ? (
                    property.data.property_facing.map((facing, idx) => (
                      <span key={idx} className="feature-tag blue">{ToFirstCapital(facing)}</span>
                    ))
                  ) : (
                    <span className="no-data-text">No data</span>
                  )}
                </div>
              </div>

              <div className="feature-card accent-green">
                <h4 className="feature-title">Property Views</h4>
                <div className="feature-tags">
                  {Array.isArray(property?.data?.property_view) && property.data.property_view.length > 0 ? (
                    property.data.property_view.map((view, idx) => (
                      <span key={idx} className="feature-tag green">{ToFirstCapital(view)}</span>
                    ))
                  ) : (
                    <span className="no-data-text">No data</span>
                  )}
                </div>
              </div>

              <div className="feature-card accent-purple">
                <h4 className="feature-title">Additional Rooms</h4>
                <div className="feature-tags">
                  {Array.isArray(property?.data?.additional_rooms) && property.data.additional_rooms.length > 0 ? (
                    property.data.additional_rooms.map((room, idx) => (
                      <span key={idx} className="feature-tag purple">{room}</span>
                    ))
                  ) : (
                    <span className="no-data-text">No additional rooms</span>
                  )}
                </div>
              </div>
            </div>

            {/* Action Cards */}
            <div className="action-cards-modern">
              <div className="action-card-modern" onClick={togglePopup}>
                <span className="action-icon-modern">✨</span>
                <div className="action-content">
                  <h4>Amenities</h4>
                  <p>Click to view all amenities</p>
                </div>
                <span className="action-arrow">→</span>
              </div>

              <div className="action-card-modern" onClick={toggleRewardPopup}>
                <span className="action-icon-modern">🎯</span>
                <div className="action-content">
                  <h4>Reward Points</h4>
                  <p>Configure rewards</p>
                </div>
                <span className="action-arrow">→</span>
              </div>

              <div className="action-card-modern discount">
                <span className="action-icon-modern">🎁</span>
                <div className="action-content">
                  <h4 style={{ color: "white" }}>Special Offer</h4>
                  <p>{property?.data?.discount_type || "No Discount"}</p>
                </div>
              </div>
            </div>

            {/* Status Selector */}
            <div className="status-selector-container">
              <label className="selector-label">Change Property Status</label>
              <select value={currentStatus} onChange={changeStatusHandler} style={{ width: "100%" }}>
                <option value="" disabled>
                  Select Status
                </option>
                {enumsData?.data?.PropertyStatus ? (
                  Object.entries(enumsData.data.PropertyStatus).map(
                    ([key, value]) => (
                      <option key={key} value={value}>
                        {ToFirstCapital(value)}
                      </option>
                    )
                  )
                ) : (
                  <option disabled>No status options available</option>
                )}
              </select>
            </div>
          </div>
        )}

        {/* Tab Content - Details */}
        {activeTab === 'details' && (
          <div className="tab-content">
            <div className="specifications-grid">
              <div className="spec-card">
                <h4>Area Details</h4>
                <div className="spec-items">
                  <div className="spec-item">
                    <span>Carpet Area</span>
                    <strong>{property?.carpet_area || "N/A"} sq.ft</strong>
                  </div>
                  <div className="spec-item">
                    <span>Unit Area</span>
                    <strong>{property?.unit_area || "N/A"} {property?.data?.unit_area_measure_in || ""}</strong>
                  </div>
                </div>
              </div>

              <div className="spec-card">
                <h4>Parking</h4>
                <div className="spec-items">
                  <div className="spec-item">
                    <span>🚗 Open Parking</span>
                    <strong>{property?.data?.open_parking || "0"} spaces</strong>
                  </div>
                  <div className="spec-item">
                    <span>🏠 Covered Parking</span>
                    <strong>{property?.data?.cover_parking || "0"} spaces</strong>
                  </div>
                </div>
              </div>

              <div className="spec-card full-width">
                <h4>Pricing Breakdown</h4>
                <div className="pricing-table">
                  <div className="pricing-row">
                    <span>Base Price per sq.ft</span>
                    <strong>₹{property?.data?.price_per_sq_ft?.toLocaleString() || "N/A"}</strong>
                  </div>
                  <div className="pricing-row">
                    <span>Total Area</span>
                    <strong>{property?.data?.unit_area || "N/A"} sq.ft</strong>
                  </div>
                  <div className="pricing-row total">
                    <span>Total Price</span>
                    <strong style={{ color: "white" }}>
                      {currency} {totalPrice}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Tab Content - Gallery */}
        {activeTab === 'gallery' && (
          <div className="tab-content">
            {/* Cover Photos */}
            <div className="gallery-section-modern">
              <h3 className="gallery-title-modern">📷 Cover Photos</h3>
              <div className="gallery-modern">
                {Array.isArray(property?.data?.cover_photos) && property.data.cover_photos.length > 0 ? (
                  property.data.cover_photos.map((photo, index) => (
                    <div
                      key={index}
                      className="gallery-item-modern"
                      onClick={() => setPreviewImage(photo.url)}
                    >
                      <img src={photo?.url} loading="lazy" alt={`Cover ${index + 1}`} />
                      <div className="gallery-overlay">
                        <span>View Full Size</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="no-data-text">No cover photos available</p>
                )}
              </div>
            </div>

            {/* Property Images */}
            <div className="gallery-section-modern">
              <h3 className="gallery-title-modern">📸 Property Gallery</h3>
              <div className="gallery-modern">
                {Array.isArray(property?.data?.images) && property.data.images.length > 0 ? (
                  property.data.images
                    .slice(0, visibleImages)
                    .map((image, idx) => (
                      <div
                        key={idx}
                        className="gallery-item-modern"
                        onClick={() => setPreviewImage(image.url)}
                      >
                        <img src={image.url} loading="lazy" alt={`Property ${idx + 1}`} />
                        <div className="gallery-overlay">
                          <span>View Full Size</span>
                        </div>
                      </div>
                    ))
                ) : (
                  <p className="no-data-text">No images available</p>
                )}
              </div>
              {property?.data?.images &&
                visibleImages < property.data.images.length && (
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <button
                      onClick={() => setVisibleImages(v => v + 6)}
                      style={{
                        padding: "10px 20px",
                        borderRadius: "8px",
                        border: "none",
                        cursor: "pointer",
                        background: "#2c4791",
                        color: "white",
                        fontWeight: "600"
                      }}
                    >
                      Load More
                    </button>
                  </div>
                )}

            </div>
          </div>
        )}
      </div>

      {/* Amenity Popup */}
      {amenityPopup && (
        <div onClick={togglePopup}>
          <div
            ref={popupRef}
            // className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <AmenitiesList
              propertyData={foundProperty || []}
              onClose={togglePopup}
            />
          </div>
        </div>
      )}

      {/* Reward Popup */}
      <RewardPointsPopup
        isOpen={rewardPopup}
        onClose={() => {
          dispatch(viewProperty(id));
          setRewardPopup(false);
        }}
        propertyId={id}
      />
      {previewImage && (
        <div
          className="image-preview-overlay"
          onClick={closePreview}
        >
          {/* Close button - top right */}
          <button
            className="preview-close-btn"
            onClick={closePreview}
            aria-label="Close preview"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>

          {/* Zoom indicator */}
          <div className="zoom-indicator">
            {Math.round(zoom * 100)}%
          </div>

          {/* Image container */}
          <div
            className="preview-image-container"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={previewImage}
              alt="Full View"
              className="preview-image"
              style={{
                transform: `scale(${zoom})`,
              }}
              onWheel={(e) => {
                e.preventDefault();
                if (e.deltaY < 0) {
                  setZoom(z => Math.min(z + 0.1, 3));
                } else {
                  setZoom(z => Math.max(z - 0.1, 1));
                }
              }}
              draggable={false}
            />
          </div>

          {/* Bottom controls */}
          <div className="preview-controls">
            <button
              className="preview-control-btn"
              onClick={(e) => {
                e.stopPropagation();
                setZoom(z => Math.max(z - 0.2, 1));
              }}
              disabled={zoom <= 1}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8" />
                <path d="M8 11h6M21 21l-4.35-4.35" />
              </svg>
              <span>Zoom Out</span>
            </button>

            <button
              className="preview-control-btn reset-btn"
              onClick={(e) => {
                e.stopPropagation();
                setZoom(1);
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 12a9 9 0 0118 0 9 9 0 01-18 0" />
                <path d="M12 8v8M8 12h8" />
              </svg>
              <span>Reset</span>
            </button>

            <button
              className="preview-control-btn"
              onClick={(e) => {
                e.stopPropagation();
                setZoom(z => Math.min(z + 0.2, 3));
              }}
              disabled={zoom >= 3}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8" />
                <path d="M11 8v6M8 11h6M21 21l-4.35-4.35" />
              </svg>
              <span>Zoom In</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewProperties;